import DownloadButton from "../Button/DownloadButton";
import styles from "./AboutMe.module.css";
function AboutMe() {
  return (
    <section id="about" className={styles.about}>
      <div className={styles.left}>
        <div className={styles.imgContainer}>
          <img
            src={process.env.PUBLIC_URL + "/assets/img/computer.png"}
            alt=""
            loading="lazy"
          />
        </div>
      </div>
      <div className={styles.right}>
        <p className={styles.smallP}>About Me</p>
        <h3>Bridging the Gap Between Vision and Reality</h3>
        <p className={styles.bigP}>
          With over 3 years of professional experience under my belt, I've
          contributed to a diverse array of projects. From designing intuitive
          interfaces that drive sales to crafting applications that resonate
          with users on the go, I've honed my skills across a wide spectrum of
          platforms and technologies. Get to know me better by reading my &nbsp;
          <a
            href="http://blog.akanbijr.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            blog
          </a>
          .
        </p>
        <div className={styles.container}>
          <div className={styles.textContainer}>
            <h5>5k+ Completed Projects</h5>
            <p>
              I'm not just a developer – I'm a solutions architect. My academic
              journey, including a First Class degree in Information Technology
              and an ongoing Masters Degree in Computer Science, forms the
              bedrock of my expertise. I'm committed to constant learning,
              improvement, and research.
            </p>
          </div>
        </div>
        <div className={styles.containerAlternate}>
          <div className={styles.textContainer}>
            <h5> Beyond the Screen</h5>
            <p>
              When I'm not immersed in code, you'll find me exploring interests
              that range from football and fitness to graphics design and public
              speaking. I believe that a well-rounded life translates into
              well-rounded solutions.
            </p>
          </div>
        </div>
        <div className={styles.buttonContainer}>
          <DownloadButton>Download CV</DownloadButton>
        </div>
      </div>
    </section>
  );
}

export default AboutMe;
